export default {
    Interview: {
        alertStartMsg: "The interview has not started yet, please be patient",
        alertEndMsg: "The interview is over",
    },
    Login: {
        login: "Login",
        loginPlaceholder: "Login ID",
        detectionTips: "Before login, please proceed first",
        detectionButton: "Device detection",
        loginWarningMsg: "Login ID cannot be null",
        loginFailMsg: "Incorrect login ID or link. Please try again",
        getLoginDataFailMsg: "The login link is incorrect, please try again",
    },
    Message: {
        title: "Identity check",
        name: "name",
        gender: "gender",
        time: "Interview time",
        tips: "Click to enter the interview room, the interviewer will be able to see your status, please wait for a moment, the interviewer will enter the interview room later",
        btnStatus: [
            "Not yet started, please wait",
            "Start in minutes",
            "Seconds",
            "Enter the interview room",
            "The interview is over",
        ],
        enterStartAlert: "The interview has not started yet, please be patient",
        enterEndAlert: "Interview is over",
    },
};
